const ProgressBar = ({ value = 0, className = "" }) => {
  const pct = Math.min(Math.max(value, 0), 100);
  return (
    <div className={`w-full bg-warm-100 rounded-full h-2 overflow-hidden ${className}`} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
      <div
        className="h-full rounded-full progress-fill-saffron animate-progress"
        style={{ width: `${pct}%`, "--progress-value": `${pct}%` }}
      />
    </div>
  );
};

export default ProgressBar;
